import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Divider } from '@guildeducationinc/recess';
import { ApprovalPolicy } from '@src/components/Admin/PolicyBuilder/ApprovalPolicy';
import { WORKFLOWS } from '@src/graphql/queries/workflow';
import { DeadlineDateType, WorkflowType, } from '@src/types';
import { camelCase, cloneDeep, groupBy } from 'lodash';
import { useMemo } from 'react';
const getDefaultDeadline = (type) => {
    return {
        minInterval: {
            days: undefined,
            years: undefined,
            backward: false,
        },
        minIntervalBasedOn: type,
        maxInterval: {
            days: undefined,
            years: undefined,
            backward: false,
        },
        maxIntervalBasedOn: type,
        reminderDays: undefined,
    };
};
const EmptyPolicyConfig = {
    enableDeadline: false,
    deadline: getDefaultDeadline(DeadlineDateType.START_DATE),
    enableDocumentDeadline: false,
    documentDeadline: getDefaultDeadline(DeadlineDateType.END_DATE),
    enableWorkflow: false,
    workflowId: undefined,
    enableCourseDropoff: false,
};
export const ApprovalChainPolicy = ({ clientId, policy, onChange, readonly }) => {
    const approvalPolicy = policy;
    const { data } = useQuery(WORKFLOWS, { variables: { spec: { clientId } } });
    const workflowsByType = useMemo(() => {
        return groupBy((data?.workflows || []), w => camelCase(w.type));
    }, [data]);
    const workflowOptionsByType = useMemo(() => {
        const optionsByType = {};
        Object.entries(workflowsByType).forEach(([type, v]) => {
            optionsByType[type] = v.map(w => ({
                label: w.name,
                value: w.id,
            }));
        });
        return optionsByType;
    }, [workflowsByType]);
    const handleChange = (type, policyConfig) => {
        onChange({
            ...policy,
            [camelCase(type)]: policyConfig,
        });
    };
    return (_jsx("div", { children: _jsx("div", { className: 'flex flex-col gap-3', children: [
                WorkflowType.PROGRAM_APPROVAL,
                WorkflowType.PAYMENT_REQUEST_APPROVAL,
                WorkflowType.PREIMBURSEMENT_APPROVAL,
            ].map(type => (_jsx("div", { children: (!readonly || approvalPolicy[camelCase(type)]) && (_jsxs(_Fragment, { children: [_jsx(ApprovalPolicy, { policyConfig: approvalPolicy[camelCase(type)] || cloneDeep(EmptyPolicyConfig), type: type, workflowOptions: workflowOptionsByType[camelCase(type)] || [], onChange: config => handleChange(type, config), readonly: readonly }), _jsx(Divider, { opacity: '1', className: 'my-4' })] })) }, type))) }) }));
};
